exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Conversation .conversation-status{border-bottom-width:1px;border-bottom-style:solid;border-bottom-color:var(--border, #222);border-radius:0\n}\n.Conversation.-expanded .conversation-status:last-child{border-bottom:none;border-radius:0 0 10px 10px;border-radius:0 0 var(--panelRadius, 10px) var(--panelRadius, 10px)\n}", ""]);

// exports
